<template>
    <div class="wrapper">
        <div class="inner" :class="disable ? 'disable' : ''">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            disable: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .wrapper {
        width: 158px;
        height: 176px;
        margin-top: 20px;
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        background: #FFFFFF;
        border: 1px solid #EBEBEB;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        .inner {
            width: 85%;
            height: 84%;
            overflow: hidden;
        }
        .disable {
            opacity: 0.4;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Card.vue